import { useQuery, useMutation } from "@apollo/client";
import { GET_ECONOMY_CONFIG, UPDATE_ECONOMY_CONFIG } from "../graphql";
import type { EconomyConfig, UpdateEconomyConfigInput } from "../types";

// ─── Queries ─────────────────────────────────────────────────────────────────

export function useEconomyConfig() {
  return useQuery<{ economyConfig: EconomyConfig }>(GET_ECONOMY_CONFIG, {
    fetchPolicy: "cache-and-network",
  });
}

// ─── Mutations ───────────────────────────────────────────────────────────────

export function useUpdateEconomyConfig() {
  return useMutation<
    { updateEconomyConfig: EconomyConfig },
    { input: UpdateEconomyConfigInput }
  >(UPDATE_ECONOMY_CONFIG, {
    refetchQueries: ["EconomyConfig"],
  });
}
